import ArticleLayout from '@/components/feature/ArticleLayout';
import articleContents from '@/mocks/article-content';

export default function ArticleMiglioriProdotti() {
  return <ArticleLayout article={articleContents['migliori-prodotti-itaobuy']} />;
}